import axios from 'axios';
import store from '@/store/Store';

// @ts-ignore
const API_URL = import.meta.env.VITE_API_URL;

export const fetchKoriList = async (before, lastId) => {
  const limit = 10;
  const token = store.getState().auth.token;

  if (!token) throw new Error('Not authenticated!');

  const params = { limit };
  if (before) params.before = before;
  if (lastId) params.lastId = lastId;

  const res = await axios.get(API_URL + '/kori/koritBeforeDate', {
    params,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return res.data;
};

export const fetchKoriListByKeyword = async (keyword) => {
  const limit = 10;
  const token = store.getState().auth.token;

  // TODO: tähän joku uloskirjautumis-homma?
  if (!token) throw new Error('Not authenticated!');

  const res = await axios.get(API_URL + '/kori/koritByKeyword', {
    params: { keyword },
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return res.data;
};

export const fetchKoriById = async (id) => {
  const token = store.getState().auth.token;

  if (!token) throw new Error('Not authenticated!');

  const res = await axios.get(`${API_URL}/kori/haku/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return res.data;
};

export const fetchKoriData = async ({ id }) => {
  const token = store.getState().auth.token;
  if (!token) throw new Error('Not authenticated!');

  try {
    const res = await axios.get(`${API_URL}/kori/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return res.data;
  }
  catch (error) {
    console.error('err', error);
    return {};
  }
};

export const updateKoriLisatieto = async ({ id, updatedLisatieto, originalLisatieto }) => {
  const token = store.getState().auth.token;
  if (!token) throw new Error('Not authenticated!');

  await axios.post(
    `${API_URL}/kori/${id}/kuvaus/update`,
    {
      updates: {
        lisatieto: {
          originalValue: originalLisatieto,
          updatedValue: updatedLisatieto,
        },
      },
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
};

export const updateKoriAsiakasinfo = async ({ id, updatedAsiakasinfo, originalAsiakasinfo }) => {
  const token = store.getState().auth.token;
  if (!token) throw new Error('Not authenticated!');

  await axios.post(
    `${API_URL}/kori/${id}/kuvaus/update`,
    {
      updates: {
        asiakasinfo: {
          originalValue: originalAsiakasinfo,
          updatedValue: updatedAsiakasinfo,
        },
      },
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
};

export const updateKoriOmistajainfo = async ({ id, updatedOmistajainfo, originalOmistajainfo }) => {
  const token = store.getState().auth.token;
  if (!token) throw new Error('Not authenticated!');

  await axios.post(
    `${API_URL}/kori/${id}/kuvaus/update`,
    {
      updates: {
        omistajainfo: {
          originalValue: originalOmistajainfo,
          updatedValue: updatedOmistajainfo,
        },
      },
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
};

export const updateKoriNimi = async ({ id, nimi, updatedNimi }) => {
  const token = store.getState().auth.token;
  if (!token) throw new Error('Not authenticated!');

  await axios.post(
    `${API_URL}/kori/${id}/tekstit/update`,
    {
      updates: {
        korin_nimi: {
          originalValue: nimi,
          updatedValue: updatedNimi,
        },
      },
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
};
